/* unplugin-vue-components disabled */import { render } from "./loader.vue?vue&type=template&id=3f299cc3&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import "./loader.vue?vue&type=style&index=0&id=3f299cc3&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f299cc3"],['__file',"src/controls/loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f299cc3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f299cc3', __exports__)) {
    api.reload('3f299cc3', __exports__)
  }
  
  module.hot.accept("./loader.vue?vue&type=template&id=3f299cc3&scoped=true", () => {
    api.rerender('3f299cc3', render)
  })

}


export default __exports__